import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderRoot";
import { WebsiteBuilderActionType } from "../../websiteBuilderAction";
import {
  IWebsiteBuilderSectionBase,
  TWebsiteBuilderSectionChild,
} from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderSection";
import { TWebsiteBuilderElement } from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderElement";
import { TWebsiteBuilderContainer } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderContainer";

export interface IBringToBackElementPayload {
  id: string;
  parentId: string;
  originalZIndex: number;
  inverse: boolean;
}

export interface IBringToBackElementAction {
  type: typeof WebsiteBuilderActionType.BRING_TO_BACK_ELEMENT;
  payload: IBringToBackElementPayload;
}

export function getBringToBackElementInverseAction(action: IBringToBackElementAction): IBringToBackElementAction {
  const { id, parentId, originalZIndex } = action.payload;

  return {
    type: WebsiteBuilderActionType.BRING_TO_BACK_ELEMENT,
    payload: {
      id,
      parentId,
      originalZIndex,
      inverse: true,
    },
  };
}

function toggleBringToBackElement<T extends IWebsiteBuilderSectionBase>(
  id: string,
  parentNode: T,
  originalZIndex: number,
  inverse: boolean,
) {
  return {
    ...parentNode,
    children: parentNode.children.map((child: TWebsiteBuilderSectionChild): TWebsiteBuilderSectionChild => {
      let zIndex: number = null;

      if (child.id === id) {
        zIndex = inverse ? originalZIndex : 0;
      } else {
        zIndex = (child.type === "element" ? child.element.zIndex : child.container.zIndex) ?? 0;
        zIndex += inverse ? -1 : 1;
      }

      if (child.type === "element") {
        const updatedElement: TWebsiteBuilderElement = {
          ...child,
        };

        updatedElement.element = {
          ...updatedElement.element,
          zIndex,
        };

        return updatedElement;
      } else {
        const updatedContainer: TWebsiteBuilderContainer = {
          ...child,
        };

        updatedContainer.container = {
          ...updatedContainer.container,
          zIndex,
        };

        return updatedContainer;
      }
    }),
  };
}

export function applyBringToBackElementTreeChange(
  tree: IWebsiteBuilderRoot,
  action: IBringToBackElementAction,
): IWebsiteBuilderRoot {
  const { id, parentId, originalZIndex, inverse } = action.payload;

  if (originalZIndex == null || originalZIndex === 0) {
    return tree;
  }

  let header = tree.header;
  let children = tree.children;
  let footer = tree.footer;

  if (header.id === parentId) {
    header = toggleBringToBackElement(id, header, originalZIndex, inverse);
  } else if (footer.id === parentId) {
    footer = toggleBringToBackElement(id, footer, originalZIndex, inverse);
  } else {
    children = children.map(child => {
      if (child.id === parentId) {
        return toggleBringToBackElement(id, child, originalZIndex, inverse);
      } else {
        return child;
      }
    });
  }

  const updatedTree: IWebsiteBuilderRoot = {
    ...tree,
    header,
    children,
    footer,
  };

  return updatedTree;
}
